<!--站点自定义模板-->
<template>
    <div class="content">
        <div class="searchContent">

            <!--<el-select v-model="orgId" clearable filterable placeholder="请选择检测站点" @change="baseCacllback">
                <el-option v-for="item in orgArr" :key="item.orgId" :label="item.orgName" :value="item.orgId"></el-option>
            </el-select>-->

            <div class="p_select">
                <div class="search_label">部位</div>
                <el-select v-model="positionId" clearable filterable placeholder="请选择部位" @change="baseCacllback">
                    <el-option v-for="item in positionArr" :key="item.positionId" :label="item.positionName"
                               :value="item.positionId"></el-option>
                </el-select>
            </div>
            <div class="p_select">
                <a class="search_btn" @click="baseCacllback">查询</a>
            </div>
            <div class="p_select" style="float: right;">
                <a class="add_btn" @click="addItem"><i class="el-icon-plus"></i>新增</a>
            </div>

            <!--<el-button type="primary" style="margin-left:15px;" @click="baseCacllback">查询</el-button>-->
            <!--<el-button type="primary" style="margin-left:15px;" icon="el-icon-plus" @click="addItem">新增</el-button>-->
        </div>
        <div class="list_content">
            <el-table :data="listData" :height=winHeight>
                <el-table-column prop="resultConfigId" label="部位结果模板ID"></el-table-column>
                <el-table-column prop="resultTitle" label="模板名称"></el-table-column>
                <el-table-column prop="resultContent"  label="模板内容"></el-table-column>
                <el-table-column label="部位检查">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isHandle ==0" style="color: #ff4949">正常使用</span>
                        <span v-if="scope.row.isHandle ==1" style="color: #13ce66">异常使用</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="editItem(scope.row)" class="update_btn" size="small">修改</el-button>
                        <el-button @click="deleteItem(scope.row)" class="update_btn" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                           :current-page="pageNo" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>


        <!--<el-dialog :visible.sync="showAddData" title="新增部位自定义模板" width="40%" :close-on-click-modal="false"
                   @close="noUpdateData">
            <el-form ref="form" :model="palnForm" label-width="100px" style="height: 300px">
                <el-form-item label="方案名称:" required>
                    <el-select v-model="positionId" disabled style="width:100%">
                        <el-option v-for="item in positionArr" :key="item.positionId" :label="item.positionName"
                                   :value="item.positionId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模板标题:" required>
                    <el-input v-model="palnForm.resultTitle" placeholder="请输入模板标题"></el-input>
                </el-form-item>
                <el-form-item label="模板内容:" required>
                    <el-input type="textarea" v-model="palnForm.resultContent" placeholder="请输入模板内容"></el-input>
                </el-form-item>
                <el-form-item label="使用情况:" required>
                    <span style="margin-right: 15px;">正常使用</span>
                    <el-switch v-model="isHandle1"></el-switch>
                    <span style="color:#409EFF;margin-left: 15px;">异常使用</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitAdd">确认新增</el-button>
                    <el-button @click="noUpdateData">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>-->

        <!--<el-dialog :visible.sync="showEditData" title="修改部位自定义模板" width="40%" :close-on-click-modal="false"
                   @close="noUpdateData">
            <el-form ref="form" :model="palnForm" label-width="100px" style="height: 300px">
                <el-form-item label="模板ID:" required>
                    <el-input v-model="resultConfigId" disabled></el-input>
                </el-form-item>
                <el-form-item label="模板标题:" required>
                    <el-input v-model="palnForm.resultTitle" placeholder="请输入模板标题"></el-input>
                </el-form-item>
                <el-form-item label="模板内容:">
                    <el-input type="textarea" v-model="palnForm.resultContent" placeholder="请输入模板内容"></el-input>
                </el-form-item>
                <el-form-item label="使用情况:">
                    <span style="margin-right: 15px;">正常使用</span>
                    <el-switch v-model="isHandle2"></el-switch>
                    <span style="color:#409EFF;margin-left: 15px;">异常使用</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitEdit">确认修改</el-button>
                    <el-button @click="noUpdateData">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>-->


        <el-drawer
                title="新增部位自定义模板"
                :visible.sync="showAddData"
                direction="rtl"
                :wrapperClosable=true
                @close="noUpdateData">

            <el-form ref="form" :model="palnForm" label-width="100px" style="height: 300px">
                <el-form-item label="方案名称:" required>
                    <el-select v-model="positionId" disabled style="width:100%">
                        <el-option v-for="item in positionArr" :key="item.positionId" :label="item.positionName"
                                   :value="item.positionId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模板标题:" required>
                    <el-input v-model="palnForm.resultTitle" placeholder="请输入模板标题"></el-input>
                </el-form-item>
                <el-form-item label="模板内容:" required>
                    <el-input type="textarea" v-model="palnForm.resultContent" placeholder="请输入模板内容"></el-input>
                </el-form-item>
                <el-form-item label="使用情况:" required>
                    <span style="margin-right: 15px;">正常使用</span>
                    <el-switch v-model="isHandle1"></el-switch>
                    <span style="color:#409EFF;margin-left: 15px;">异常使用</span>
                </el-form-item>
                <!--<el-form-item>
                    <el-button type="primary" @click="submitAdd">确认新增</el-button>
                    <el-button @click="noUpdateData">取消</el-button>
                </el-form-item>-->
            </el-form>

            <div class="position_box_btn">
                <a class="sure_btn" @click="submitAdd">确认新增</a>
                <a class="cancel_btn" @click="noUpdateData">取消</a>
            </div>
        </el-drawer>
        <el-drawer
                title="修改部位自定义模板"
                :visible.sync="showEditData"
                direction="rtl"
                :wrapperClosable=true
                @close="noUpdateData">

            <el-form ref="form" :model="palnForm" label-width="100px" style="height: 300px">
                <el-form-item label="模板ID:" required>
                    <el-input v-model="resultConfigId" disabled></el-input>
                </el-form-item>
                <el-form-item label="模板标题:" required>
                    <el-input v-model="palnForm.resultTitle" placeholder="请输入模板标题"></el-input>
                </el-form-item>
                <el-form-item label="模板内容:">
                    <el-input type="textarea" v-model="palnForm.resultContent" placeholder="请输入模板内容"></el-input>
                </el-form-item>
                <el-form-item label="使用情况:">
                    <span style="margin-right: 15px;">正常使用</span>
                    <el-switch v-model="isHandle2"></el-switch>
                    <span style="color:#409EFF;margin-left: 15px;">异常使用</span>
                </el-form-item>
                <!--<el-form-item>
                    <el-button type="primary" @click="submitEdit">确认修改</el-button>
                    <el-button @click="noUpdateData">取消</el-button>
                </el-form-item>-->
            </el-form>

            <div class="position_box_btn">
                <a class="sure_btn" @click="submitEdit">确认修改</a>
                <a class="cancel_btn" @click="noUpdateData">取消</a>
            </div>
        </el-drawer>


        <el-dialog title="删除部位自定义模板" :visible.sync="showDeleteData" width="40%">
            <br />
            <div class="selectType" style="text-align:left;margin-left:10%">
                <p>请确认时候删除此自定义模板？</p>
            </div>
            <br />
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="marksureDelete">确定删除</el-button>
                <el-button @click="showDeleteData=false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  export default {
    data() {
      return {
        signInfo:'',
        listData: [],
        total: 0,
        pageNo: 1,
        pageSize: 10,
        orgArr: [],
        orgId: 0,
        positionArr: [],
        positionId: 0,
        showAddData: false,
        resultConfigId:0,
        isHandle1 : false,
        isHandle2 : false,
        palnForm: {
          resultTitle: '',
          resultContent: '',
        },
        showEditData: false,
        showDeleteData: false,
      };
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.signInfo = signInfo
      this.getPositionList()
      this.winHeight = net.setWindowHeight() - 80
    },
    methods: {

      // 获取站点所有部位
      getPositionList() {
        const params = {
          orgId: this.signInfo.orgId,
          showType: 0,
        }
        net.request("admin/manage/parts/getPositionList", "post", params).then(res => {
          if (res.code === 0) {
            this.positionArr = res.data
            this.positionId = res.data[0].positionId;
            this.baseCacllback();
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },

      baseCacllback() {
        if (this.positionId > 0) {
          this.getListData()
        }
      },
      getListData() {
        const params = {
          orgId: this.signInfo.orgId,
          positionId: this.positionId,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        net.request("admin/manage/orgPositionResult/queryPage", "post", params, null).then(res => {
          if (res.code === 0) {
            this.listData = res.data.rows
            this.total = res.data.total
          } else {
            net.message(this, res.msg, "warning");
          }
        })
      },
      addItem() {
        this.showAddData = true
        this.palnForm.resultTitle = ''
        this.palnForm.resultContent = ''
      },
      submitAdd() {
        if (this.palnForm.resultTitle == '' || this.palnForm.resultContent == null) {
          net.message(this, '必填项不能为空', "error");
          return
        }
        const params = {
          orgId: this.orgId,
          positionId: this.positionId,
          resultTitle: this.palnForm.resultTitle,
          resultContent: this.palnForm.resultContent,
          isHandle: this.isHandle1 ? 1 : 0
        }
        net.request("admin/manage/orgPositionResult/addOrgPositionResult", "post", params, null).then(res => {
          if (res.code === 0) {
            this.showAddData = false
            net.message(this, res.msg, "success");
            this.baseCacllback()
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      editItem(row) {
        this.resultConfigId = row.resultConfigId
        this.palnForm.resultTitle = row.resultTitle
        this.palnForm.resultContent = row.resultContent
        this.isHandle2 = row.isHandle == 1 ? true : false
        this.showEditData = true
      },
      submitEdit() {
        if (this.palnForm.resultTitle == '' || this.palnForm.resultContent == null) {
          net.message(this, '必填项不能为空', "error");
          return
        }
        const params = {
          resultConfigId: this.resultConfigId,
          orgId: this.orgId,
          positionId: this.positionId,
          resultTitle: this.palnForm.resultTitle,
          resultContent: this.palnForm.resultContent,
          isHandle: this.isHandle2 ? 1 : 0
        }
        net.request("admin/manage/orgPositionResult/editOrgPositionResult", "post", params, null).then(res => {
          if (res.code === 0) {
            this.showEditData = false
            net.message(this, res.msg, "success");
            this.baseCacllback()
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      deleteItem(row) {
        this.resultConfigId =  row.resultConfigId
        this.showDeleteData = true
      },
      marksureDelete(){
        const params = {
          resultConfigId: this.resultConfigId,
        }
        net.request("admin/manage/orgPositionResult/delete", "post", params, null).then(res => {
          if (res.code === 0) {
            net.message(this, res.msg, "success");
            this.showDeleteData = false
            this.baseCacllback()
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      noUpdateData() {
        this.showAddData = false
        this.showEditData = false
        this.getListData()
      },

      handleSizeChange(val) {
        this.pageSize = val;
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageNo = val
        this.getListData()
      },
    }
  };
</script>


<style lang='less' scoped>
    .content {
        padding-left: 24px;
        .searchContent {
            height: 60px;
            background: #fff;
            margin: 24px 0 0px 0;
            /*display: flex;*/
            /*flex-direction: row;*/
            padding-left: 24px;
            padding-top: 24px;
            .p_select {
                display: flex;
                padding: 0 24px 24px 0;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
        }
    }

    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }


    .pagination {
        position: relative;
        margin-top: 0;
        background: #fff;
        padding-top: 24px;
        padding-bottom: 10px;
        .el-pagination {
            position: absolute;
            right: 24px;
            .el-pager li:not(.disabled) {
                .active {
                    background: #009688 !important;
                }
            }
        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #009688;
    }
    .select_box {
        text-align: left;
        margin-bottom: 10px;
        .select_title {
            display: inline-block;
            width: 100px;
            text-align: right;
            margin-right: 20px;
        }
    }
    .update_btn {
        width: 54px;
        height: 28px;
        background: rgba(148, 170, 204, 0.08);
        border: 1px solid #E3E7ED;
        border-radius: 14px;
        font-size: 12px;
        color: #364556;
        text-align: center;
    }
</style>
